import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

@Injectable()
export class PaymentProcessingService {
    constructor(private apiHttp: ApiHttp) {
    }

    public adjustRiderWalletBalance(data: any, messageService: MessageService, idempotencyKey: string): Promise<any> {
        return this.idempotentPost('api/PaymentProcessing/AdjustRiderWalletBalance', data, messageService, idempotencyKey);
    }

    public adjustUserWalletBalance(data: any, messageService: MessageService, idempotencyKey: string): Promise<any> {
        return this.idempotentPost('api/PaymentProcessing/AdjustUserWalletBalance', data, messageService, idempotencyKey);
    }

    public refundTransaction(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/PaymentProcessing/RefundTransaction', data, messageService);
    }

    public reward4wXpress50Riders(data: any, messageService: MessageService): Promise<any> {
        return this.apiHttp.post('api/PaymentProcessing/Reward4wXpress50Riders', data, messageService);
    }

    private idempotentPost(url: string, data: any, messageService: MessageService, idempotencyKey: string): Promise<any> {
        return this.apiHttp.post(url, data, messageService, { headers: { 'Idempotency-Key': idempotencyKey } });
    }
}
